module.exports = __webpack_public_path__ + "img/(1) - Pericuinkle.c7584c47.png";